/* Brand page: chapters (sections/laylo-brand-chapters.liquid)
   - Computers: pinned wheel. One wheel gesture or key press moves one chapter;
     the first and last chapter let the page scroll on normally.
   - Phones and tablets: a number dial that follows the chapter list.
   - Both: a round back to top button with a progress ring. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pad = function (n) { return n < 10 ? '0' + n : String(n); };
  var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  function init(root) {
    if (!root || root._bc) return;
    root._bc = true;
    root.classList.add('bc--js');
    document.documentElement.style.scrollBehavior = 'auto';

    var wheel = root.querySelector('[data-bc-wheel]');
    var arc = root.querySelector('[data-bc-arc]');
    var nums = Array.prototype.slice.call(root.querySelectorAll('[data-bc-num]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bc-dot]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bc-pn]'));
    var curN = root.querySelector('[data-bc-cur-n]');
    var cur = root.querySelector('[data-bc-cur]');
    var hint = root.querySelector('[data-bc-hint]');
    var list = root.querySelector('[data-bc-list]');
    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-bc-ch]'));
    var dial = root.querySelector('[data-bc-dial]');
    var track = root.querySelector('[data-bc-track]');
    var dialNums = Array.prototype.slice.call(root.querySelectorAll('[data-bc-dial-num]'));
    var dialTitle = root.querySelector('[data-bc-tt]');
    var topBtn = root.querySelector('[data-bc-top]');
    var topRing = root.querySelector('[data-bc-top-ring]');
    var N = panels.length;

    var R = 380, NR = R + 46, STEP = 21, BIG = 64, CX = -560 + R;
    var head = 0;
    var animating = false, lastWheel = 0, current = -1, dialCurrent = -1;

    function headerHeight() {
      var h = document.querySelector('.header-section');
      return h ? h.offsetHeight : 0;
    }

    function headerBottom() {
      var h = document.querySelector('.header-section');
      return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
    }

    function wheelOn() {
      return !!wheel && wheel.offsetParent !== null;
    }

    /* Scroll animation, eased; instant when motion is reduced */
    function animTo(to, duration) {
      if (reduce.matches) {
        window.scrollTo(0, to);
        return;
      }
      var from = window.scrollY, t0 = performance.now();
      animating = true;
      (function step(now) {
        var t = Math.min(1, (now - t0) / duration);
        window.scrollTo(0, from + (to - from) * ease(t));
        if (t < 1) requestAnimationFrame(step);
        else { animating = false; lastWheel = performance.now(); }
      })(t0);
    }

    /* Where the pinned stretch starts and how long it is */
    function geo() {
      var r = wheel.getBoundingClientRect();
      return { top0: r.top + window.scrollY - head, tot: Math.max(1, r.height - window.innerHeight + head) };
    }

    function fraction() {
      var g = geo();
      return Math.max(0, Math.min(1, (window.scrollY - g.top0) / g.tot));
    }

    function index() {
      return N > 1 ? Math.round(fraction() * (N - 1)) : 0;
    }

    function goTo(i) {
      i = Math.max(0, Math.min(N - 1, i));
      var g = geo();
      var to = g.top0 + (N > 1 ? g.tot * (i / (N - 1)) : 0);
      animTo(to, Math.min(900, 550 + Math.abs(to - window.scrollY) / window.innerHeight * 40));
    }

    function inside() {
      if (!wheelOn()) return false;
      var g = geo();
      return window.scrollY >= g.top0 - 2 && window.scrollY <= g.top0 + g.tot + 2;
    }

    /* Wheel: numbers and dots on the arc, the active panel, label, hint and progress */
    function updateWheel() {
      if (!wheelOn()) return;
      var f = fraction();
      var p = f * (N - 1);
      var k = Math.round(p);
      var cy = arc.clientHeight / 2;

      nums.forEach(function (el, i) {
        var a = (i - p) * STEP * Math.PI / 180;
        var d = Math.abs(i - p);
        var s = Math.max(26, 64 - d * 38) / BIG;
        var x = CX + NR * Math.cos(a), y = cy + NR * Math.sin(a);
        el.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + (y - BIG / 2).toFixed(2) + 'px,0) rotate(' + (a * 180 / Math.PI).toFixed(3) + 'deg) scale(' + s.toFixed(4) + ')';
        el.style.opacity = Math.max(0, 1 - d * 0.28).toFixed(3);
        el.classList.toggle('is-on', i === k);
      });

      dots.forEach(function (el, i) {
        var a = (i - p) * STEP * Math.PI / 180;
        el.style.left = (CX + R * Math.cos(a)).toFixed(2) + 'px';
        el.style.top = (cy + R * Math.sin(a)).toFixed(2) + 'px';
        el.style.opacity = Math.max(0, 1 - Math.abs(i - p) * 0.28).toFixed(3);
        el.classList.toggle('is-on', i === k);
      });

      if (k !== current) {
        current = k;
        panels.forEach(function (el, i) {
          var on = i === k;
          el.classList.toggle('is-on', on);
          if (on) el.removeAttribute('aria-hidden');
          else el.setAttribute('aria-hidden', 'true');
        });
        curN.textContent = 'Chapter ' + pad(k + 1) + ' / ' + pad(N);
      }

      cur.style.left = (CX + NR + 105) + 'px';
      hint.style.opacity = f < 0.03 ? 1 : 0;
    }

    /* Dial: the last chapter whose top has passed 45% of the screen */
    function updateDial() {
      if (!dial || getComputedStyle(dial).display === 'none') return;
      dial.style.top = headerBottom() + 'px';
      var st = list.getBoundingClientRect();
      var vh = window.innerHeight;
      dial.classList.toggle('is-hidden', !(st.top < vh * 0.5 && st.bottom > vh * 0.4));
      var k = 0;
      chapters.forEach(function (c, i) { if (c.getBoundingClientRect().top < vh * 0.45) k = i; });
      if (k !== dialCurrent) {
        dialCurrent = k;
        dialNums.forEach(function (b, i) { b.classList.toggle('is-on', i === k); });
        dialTitle.textContent = 'Chapter ' + pad(k + 1) + ' / ' + pad(N);
      }
      var a = dialNums[k];
      if (a) track.style.transform = 'translateX(' + (-(a.offsetLeft + a.offsetWidth / 2 - window.innerWidth / 2)) + 'px)';
    }

    function updateTop() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var f = max > 0 ? window.scrollY / max : 0;
      topRing.style.strokeDashoffset = (175.9 * (1 - f)).toFixed(1);
      topBtn.classList.toggle('is-shown', window.scrollY > window.innerHeight * 0.8);
    }

    var queued = false;
    function update() {
      queued = false;
      updateWheel();
      updateDial();
      updateTop();
    }
    function queue() {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    }
    function measure() {
      head = headerHeight();
      root.style.setProperty('--bc-head', head + 'px');
      current = -1;
      dialCurrent = -1;
      update();
    }

    /* Input on computers */
    window.addEventListener('wheel', function (e) {
      if (!inside()) return;
      var dir = Math.sign(e.deltaY);
      if (!dir) return;
      var k = index();
      if ((dir > 0 && k === N - 1) || (dir < 0 && k === 0)) {
        if (!animating) return;
      }
      e.preventDefault();
      var now = performance.now();
      var gap = now - lastWheel;
      lastWheel = now;
      if (animating || gap < 200) return;
      goTo(k + dir);
    }, { passive: false });

    window.addEventListener('keydown', function (e) {
      if (!inside() || animating) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      var dir = 0;
      if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') dir = 1;
      if (e.key === 'ArrowUp' || e.key === 'PageUp') dir = -1;
      if (!dir) return;
      var k = index();
      if ((dir > 0 && k === N - 1) || (dir < 0 && k === 0)) return;
      e.preventDefault();
      goTo(k + dir);
    });

    nums.forEach(function (el, i) {
      el.addEventListener('click', function () { goTo(i); });
    });

    dialNums.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var c = chapters[i];
        animTo(c.getBoundingClientRect().top + window.scrollY - headerBottom() - dial.offsetHeight + 10, 650);
      });
    });

    if (root.querySelector('[data-bc-up]')) {
      root.querySelector('[data-bc-up]').addEventListener('click', function () { animTo(0, 900); });
    }

    topBtn.addEventListener('click', function () {
      animTo(0, Math.min(1600, 800 + window.scrollY / 12));
    });

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', measure);
    if (reduce.addEventListener) reduce.addEventListener('change', measure);
    measure();
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bc]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', start);
})();
